import Demo from './demo'
import Emergency from './emergency'
import UnifiedRelease from './unifiedRelease'
import serviceAlarm from './serviceAlarm'
import seekHelp from './seekHelp'
import Area from './area'
import Monitor from './monitor'
import MonitorGb from './monitorGb'
import Broadcast from './broadcast'
import CarPark from './carpark'
import ClusterServer from './clusterServer'
import LED from './led'
import Equipment from './equipment'
import Warn from './warn'
import Cableway from './cableway'
import Wifi from './wifi'
import Opinion from './Opinion'
import Face from './Face'
import MaterialManage from './MaterialManage'
import POI from './poi'
import SMS from './sms'
import SystemLog from './systemLog'
import DataDetection from './dataDetection'
import Home from './home'
import VehicleScheduling from './vehicleScheduling'
import Map from './map'
import Uniformauth from './uniformauth'
import Weather from './weather'
import SmartToilet from './smartToilet'
import SmartTrash from './smartTrash'
import Complaint from './complaint'
import UniformSysConfig from './uniformSysConfig'
import TourReport from './TourReport'
import about from './about'
import EquMonitor from './equMonitor'
import IndustrialMonitoring from './IndustrialMonitoring'   // 产业监测
import business from './business'
import Lamp from './lamp'
import Ticket from './ticket'
import DynEnvironment from './dynEnvironment'
import Irrigation from './irrigation'
import Light from './light'
import Fire from './fire'
import Room from './room'
import Permission from './permission'
import DataAnalysis from './dataAnalysis'
import DataAnalysisHegu from './dataAnalysisHegu'
import Iot from './iot'
import SmartWaterManage from './smartWaterManage'

const plugins = {
    Demo,
    Emergency,
    UnifiedRelease,
    serviceAlarm,
    seekHelp,
    Area,
    Monitor,
    MonitorGb,
    Broadcast,
    CarPark,
    ClusterServer,
    LED,
    Equipment,
    Warn,
    Cableway,
    Wifi,
    Opinion,
    MaterialManage,
    POI,
    SMS,
    SystemLog,
    DataDetection,
    Home,
    VehicleScheduling,
    Map,
    Uniformauth,
    Weather,
    SmartToilet,
    SmartTrash,
    Complaint,
    Face,
    UniformSysConfig,
    TourReport,
    about,
    EquMonitor,
    IndustrialMonitoring,
    business,
    Lamp,
    Ticket,
    DynEnvironment,
    Irrigation,
    Light,
    Fire,
    Room,
    Permission,
    DataAnalysis,
    DataAnalysisHegu,
    Iot,
    SmartWaterManage
};

export default plugins;
